/**
 * Inicialización opcional de Sentry. Se llama desde `main.ts` antes de
 * `bootstrapApplication`. Si `sentryDsn` está vacío, es no-op.
 *
 * Cuando esté listo el deploy a staging/prod, agregar `@sentry/angular` a las
 * deps y reemplazar el placeholder por:
 *   import * as Sentry from '@sentry/angular';
 *   Sentry.init({ dsn, environment, tracesSampleRate: 0.1 });
 */
export interface SentryInitOptions {
  dsn?: string;
  environment?: string;
  release?: string;
}

export function initSentry(opts: SentryInitOptions): void {
  if (!opts.dsn) return;
  // eslint-disable-next-line no-console
  console.info(`[sentry] init placeholder env=${opts.environment ?? 'dev'} dsn=set`);
  // TODO: integrar @sentry/angular cuando se confirme el plan de pricing.
}
